module.exports = __webpack_public_path__ + "img/loading-img.e6c5dfff.gif";